import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiFormLabel: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 500,
      color: colors.black[700],

      '& .MuiFormLabel-asterisk': { color: colors.red[600] },

      ...theme.applyStyles('dark', {
        color: colors.black[100],
      }),
    }),
  },
};
